import { NgModule, Injector, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { IconModule } from 'app/icon/icon.module';
import { CdkScrollableModule, ScrollingModule } from '@angular/cdk/scrolling';
import { LetModule, PushModule } from '@ngrx/component';
import { QuillModule  } from 'ngx-quill'
import Counter from './structure/counter';

import { CampaignListComponent } from './components/campaign-list/campaign-list.component';
import { createCustomElement } from '@angular/elements';
import { DialogModule } from '../dialog/dialog.module';
import { ToastModule } from '../toast/toast.module';
import { CampaignTypeComponent } from './components/campaign-type/campaign-type.component';
import { CampaignDonationComponent } from './components/campaign-donation/campaign-donation.component';
import { CampaignLongPledgeComponent } from './components/campaign-long-pledge/campaign-long-pledge.component';
import { CampaignTicketingComponent } from './components/campaign-ticketing/campaign-ticketing.component';
import { CampaignPeerToPeerFundraisingComponent } from './components/campaign-peer-to-peer-fundraising/campaign-peer-to-peer-fundraising.component';
import { CampaignAuctionComponent } from './components/campaign-auction/campaign-auction.component';
import { CampaignLastHeroComponent } from './components/campaign-last-hero/campaign-last-hero.component';
import { CampaignHinduTemplePujaComponent } from './components/campaign-hindu-temple-puja/campaign-hindu-temple-puja.component';
import { CampaignMerchandiseComponent } from './components/campaign-merchandise/campaign-merchandise.component'; 
import { CampaignPartySignUpComponent } from './components/campaign-party-signup/campaign-party-signup.component';
import { AngularCropperjsModule } from 'angular-cropperjs';
import { CoreModule } from 'app/core/core.module';
import { RecurringDonationComponent } from './components/recurring-donation/recurring-donation.component';
import { CampaignGeneralInfoComponent } from './components/campaign-general-info/campaign-general-info.component';
import { CampaignEmailSettingsComponent } from './components/campaign-email-settings/campaign-email-settings.component';
import { CampaignCoverFeeSettingsComponent } from './components/campaign-cover-fee-settings/campaign-cover-fee-settings.component';
import { CampaignDonationSettingsComponent } from './components/campaign-donation-settings/campaign-donation-settings.component';
import { CampaignTicketingTypeComponent } from './components/campaign-ticketing-type/campaign-ticketing-type.component';
import { CampaignTicketingSettingsComponent } from './components/campaign-ticketing-settings/campaign-ticketing-settings.component';
import { CampaignEventSettingsComponent } from './components/campaign-event-settings/campaign-event-settings.component';
import { CampaignGuestInformationComponent } from './components/campaign-guest-information/campaign-guest-information.component';

import { GoogleMapsAutocompleteModule } from 'app/google-maps-autocomplete/google-maps-autocomplete.module';
import { CampaignEventVenueComponent } from './components/campaign-event-venue/campaign-event-venue.component';
import { CampaignLongPledgeSettingsComponent } from './components/campaign-long-pledge-settings/campaign-long-pledge-settings.component';
import { CampaignPeerToPeerFundraisingSettingsComponent } from './components/campaign-peer-to-peer-fundraising-settings/campaign-peer-to-peer-fundraising-settings.component';
import { CampaignLastHeroSettingsComponent } from './components/campaign-last-hero-settings/campaign-last-hero-settings.component';
import { CampaignAuctionSettingsComponent } from './components/campaign-auction-settings/campaign-auction-settings.component';
import { CampaignHinduTemplePujaSettingsComponent } from './components/campaign-hindu-temple-puja-settings/campaign-hindu-temple-puja-settings.component';
import { CampaignPujaSettingsComponent } from './components/campaign-puja-settings/campaign-puja-settings.component';
import { CampaignMerchandiseSettingsComponent } from './components/campaign-merchandise-settings/campaign-merchandise-settings.component';
import { CampaignPartySignUpSettingsComponent } from './components/campaign-party-signup-settings/campaign-party-signup-settings.component'
import { CampaignOptionListComponent } from './components/campaign-option-list/campaign-option-list.component';
import { CampaignDeletedOptionListComponent } from './components/campaign-deleted-option-list/campaign-deleted-option-list.component';
import { CampaignDeletedOptionElementComponent } from './components/campaign-deleted-option-element/campaign-deleted-option-element.component';
import { CampaignDonationOptionComponent } from './components/campaign-donation-option/campaign-donation-option.component';
import { CampaignLongPledgeOptionComponent } from './components/campaign-long-pledge-option/campaign-long-pledge-option.component';
import { CampaignTicketingOptionComponent } from './components/campaign-ticketing-option/campaign-ticketing-option.component';
import { CampaignPeerToPeerFundraisingOptionComponent } from './components/campaign-peer-to-peer-fundraising-option/campaign-peer-to-peer-fundraising-option.component';
import { CampaignLastHeroOptionComponent } from './components/campaign-last-hero-option/campaign-last-hero-option.component';
import { CampaignAuctionOptionComponent } from './components/campaign-auction-option/campaign-auction-option.component';
import { CampaignHinduTemplePujaOptionComponent } from './components/campaign-hindu-temple-puja-option/campaign-hindu-temple-puja-option.component';

import { MatInputCommifiedDirective } from './directives/currency';
import { NgxCurrencyInputMode, provideEnvironmentNgxCurrency, NgxCurrencyDirective } from "ngx-currency";
import { CampaignSponsorListComponent } from './components/campaign-sponsor-list/campaign-sponsor-list.component';
import { CampaignSponsorComponent } from './components/campaign-sponsor/campaign-sponsor.component';
import { MdbCheckboxModule } from 'mdb-angular-ui-kit/checkbox';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { MdbAccordionModule } from 'mdb-angular-ui-kit/accordion';
import { MdbTabsModule } from 'mdb-angular-ui-kit/tabs';
import { MdbPopoverModule } from 'mdb-angular-ui-kit/popover';
import { MdbModalModule } from 'mdb-angular-ui-kit/modal';
import { MdbInfiniteScrollModule } from 'mdb-angular-ui-kit/infinite-scroll';
import { MdbDragAndDropModule } from 'mdb-angular-drag-and-drop';
import { MdbAutocompleteModule } from 'mdb-angular-ui-kit/autocomplete';
import { ActionsPopoverCampaignComponent } from './components/actions-popover-campaign/actions-popover-campaign.component';
import { SharedLinkCampaignPopoverComponent } from './components/shared-link-popover/shared-link-campaign-popover.component';
import { CampaignOptionElementComponent } from './components/campaign-option-element/campaign-option-element.component';
import { RouterModule } from '@angular/router';
import { TestComponent } from './components/test/test.component';
import { CampaignTicketComboComponent } from './components/campaign-ticket-combo/campaign-ticket-combo.component';
import { CampaignBasketRaffleItemListComponent } from './components/campaign-basket-raffle-item-list/campaign-basket-raffle-item-list.component';
import { CampaignBasketRaffleItemComponent } from './components/campaign-basket-raffle-item/campaign-basket-raffle-item.component';
import { CampaignFeatureSModule } from './features/campaign-features.module';
import { CampaignPeerToPeerPercentOptionsComponent } from './components/campaign-peer-to-peer-percent-options/campaign-peer-to-peer-percent-options.component';
import { CampaignPeerToPeerAmountOptionsComponent } from './components/campaign-peer-to-peer-amount-options/campaign-peer-to-peer-amount-options.component';
import { CampaignTeamInformationComponent } from './components/campaign-team-information/campaign-team-information.component';
import { EmbeddedCampaignModalComponent } from './modals/embedded-campaign-modal/embedded-campaign-modal.component';
import { CampaignOptionActionPopoverComponent } from './components/campaign-option-action-popover/campaign-option-action-popover.component';
import { CampaignMerchandiseOptionComponent } from './components/campaign-merchandise-option/campaign-merchandise-option.component';
import { CampaignPartySignUpOptionComponent } from './components/campaign-party-signup-option/campaign-party-signup-option.component';
import { CampaignFormFieldListComponent } from './components/campaign-form-field-list/campaign-form-field-list.component';
import { MdbInputGoogleMapsAutocompleteComponent } from 'app/core/components/mdb-input-google-maps-autocomplete/mdb-input-google-maps-autocomplete.component';
import { CampaignInKindComponent } from './components/campaign-in-kind/campaign-in-kind.component';
import { CampaignInKindSettingsComponent } from './components/campaign-in-kind-settings/campaign-in-kind-settings.component';

@NgModule({
  declarations: [
    CampaignListComponent,
    CampaignTypeComponent,
    CampaignDonationComponent,
    CampaignInKindComponent,
    CampaignLongPledgeComponent,
    CampaignTicketingComponent,
    CampaignPeerToPeerFundraisingComponent,
    CampaignAuctionComponent,
    CampaignLastHeroComponent,
    CampaignHinduTemplePujaComponent,
    CampaignMerchandiseComponent,
    CampaignPartySignUpComponent,
    RecurringDonationComponent,
    CampaignGeneralInfoComponent,
    CampaignEmailSettingsComponent,
    CampaignCoverFeeSettingsComponent,
    CampaignDonationSettingsComponent,
    CampaignInKindSettingsComponent,
    CampaignTicketingTypeComponent,
    CampaignTicketingSettingsComponent,
    CampaignMerchandiseSettingsComponent,
    CampaignPartySignUpSettingsComponent,
    CampaignEventSettingsComponent,
    CampaignGuestInformationComponent,
    CampaignFormFieldListComponent,
    CampaignTicketComboComponent,
    CampaignEventVenueComponent,
    CampaignLongPledgeSettingsComponent,
    CampaignPeerToPeerFundraisingSettingsComponent,
    CampaignLastHeroSettingsComponent,
    CampaignAuctionSettingsComponent,
    CampaignHinduTemplePujaSettingsComponent,
    CampaignPujaSettingsComponent,
    CampaignOptionListComponent,
    CampaignOptionElementComponent,
    CampaignDeletedOptionListComponent,
    CampaignDeletedOptionElementComponent,
    CampaignDonationOptionComponent,
    CampaignLongPledgeOptionComponent,
    CampaignTicketingOptionComponent,
    CampaignMerchandiseOptionComponent,
    CampaignPartySignUpOptionComponent,
    CampaignPeerToPeerFundraisingOptionComponent,
    CampaignLastHeroOptionComponent,
    CampaignAuctionOptionComponent,
    CampaignHinduTemplePujaOptionComponent,
    CampaignBasketRaffleItemListComponent,
    CampaignBasketRaffleItemComponent,
    MatInputCommifiedDirective,
    CampaignSponsorListComponent,
    CampaignSponsorComponent,
    ActionsPopoverCampaignComponent,
    SharedLinkCampaignPopoverComponent,
    TestComponent,
    CampaignPeerToPeerPercentOptionsComponent,
    CampaignPeerToPeerAmountOptionsComponent,
    CampaignTeamInformationComponent,
    EmbeddedCampaignModalComponent,
    CampaignOptionActionPopoverComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CampaignFeatureSModule,
    DragDropModule,
    ClipboardModule,
    DialogModule,
    ToastModule,
    AngularCropperjsModule,
    CoreModule,
    IconModule,
    MdbCheckboxModule,
    MdbAccordionModule,
    MdbSelectModule,
    MdbTabsModule,
    MdbPopoverModule,
    GoogleMapsAutocompleteModule,
    CdkScrollableModule,
    ScrollingModule,
    MdbModalModule,
    MdbDragAndDropModule,
    MdbInfiniteScrollModule,
    MdbAutocompleteModule,
    LetModule,
    PushModule,
    RouterModule,
    QuillModule.forRoot({
      customModules: [{
        implementation: Counter,
        path: 'modules/counter'
      }]
    }),
    MdbInputGoogleMapsAutocompleteComponent,

    NgxCurrencyDirective
  ],
  exports: [],
  providers: [provideEnvironmentNgxCurrency({
    align: "left",
    allowNegative: false,
    allowZero: true,
    decimal: ".",
    precision: 0,
    prefix: "$ ",
    suffix: "",
    thousands: ",",
    nullable: true,
    min: null,
    max: null,
    inputMode: NgxCurrencyInputMode.Financial
  })],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CampaignModule {
  constructor(injector: Injector) {
    const TestElement = createCustomElement(TestComponent, {injector});

    try {
      customElements.define('paybee-test', TestElement);
    } catch(e) {}
  }
}
